import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class Announcement extends Component {
  render() {
    const { duyurular } = this.props;
    return (
      <>
        <div className="row">
          <div className="col-12 t-dashboarDuyurular">DUYURULAR</div>
        </div>

        {duyurular &&
          duyurular.map(duyuru => {
            return (

              <div className="row" key={duyuru.id}>
                <div className="t-dashboardDuyuruArea">
                  {/* Duyuru satırı*/}
                  <Link className="row no-gutters"
                        to={"/Home/AnnouncementDetail/" + duyuru.id}
                                            
                      >                  
                      
                      <div className="col-12 col-lg-1 py-1 text-center text-lg-left">
                      <i className="t-icon-bell" style={{ fontSize: "20pt" }} />
                    </div>
                    <div className="col-12 col-lg-2 py-1 text-center text-lg-left">
                      {duyuru.tarih}
                    </div>
                    <div className="col-12 col-lg-8 py-1 text-center text-lg-left">
                      {duyuru.konu}
                    </div>
                    <div className="d-none d-lg-block col-1 py-1 text-center text-lg-left">
                    <i className="t-icon-arrow-right1" style={{ fontSize: "14pt" }} />
                    </div>
                  </Link>
             
                  {/* Duyuru satırı*/}

                </div>

              </div>


            );
          })}

      </>

    );
  }
}
